import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Background, Dialog, DialogHeader, HeaderButton, Contents } from './style.js';
import Icon from '../Icon/index.js';
import Template from './Template/index.js';

function ModalDialog(_a) {
    var _b, _c, _d, _e, _f;
    var _g = _a.styleType, styleType = _g === void 0 ? 'default' : _g, headerOptions = _a.headerOptions, children = _a.children, visible = _a.visible, onClose = _a.onClose, _h = _a.zIndex, zIndex = _h === void 0 ? 8000 : _h, style = _a.style;
    var _j = useState(), modalRoot = _j[0], setModalRoot = _j[1];
    useEffect(function () {
        setModalRoot(document.body);
    }, []);
    var modal = (React.createElement(React.Fragment, null,
        React.createElement(Background, { visible: visible, onClick: onClose, zIndex: zIndex, "data-testid": "background" }),
        React.createElement(Dialog, { styleType: styleType, visible: visible, zIndex: zIndex, style: style, "data-testid": "dialog" },
            styleType === 'header' && (headerOptions === null || headerOptions === void 0 ? void 0 : headerOptions.title) && (React.createElement(DialogHeader, { border: (_b = headerOptions === null || headerOptions === void 0 ? void 0 : headerOptions.border) !== null && _b !== void 0 ? _b : true },
                React.createElement(HeaderButton, { role: "button", onClick: (_c = headerOptions.left) === null || _c === void 0 ? void 0 : _c.onClick }, (_d = headerOptions.left) === null || _d === void 0 ? void 0 : _d.label),
                React.createElement("span", { className: "header-title" }, headerOptions.title),
                (headerOptions.right && (React.createElement(HeaderButton, { role: "button", onClick: (_e = headerOptions.right) === null || _e === void 0 ? void 0 : _e.onClick }, (_f = headerOptions.right) === null || _f === void 0 ? void 0 : _f.label))) || React.createElement(Icon.XShape, { styleType: "close", onClick: onClose }))),
            React.createElement(Contents, { styleType: styleType }, children))));
    return modalRoot && visible ? ReactDOM.createPortal(modal, modalRoot) : null;
}
ModalDialog.Template = Template;

export { ModalDialog as default };
